

import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import '../../styles/Header.css'

import { FaTachometerAlt, FaWallet, FaHeadset, FaRobot,FaUser,FaSignOutAlt,FaExchangeAlt,
    FaPhoneVolume,FaSignal,FaLightbulb, FaBars, FaGraduationCap, FaWifi, FaTv, FaBell, FaUserShield, FaCog, FaChevronDown, FaChevronUp, FaDatabase, FaUsers, FaPhone } from 'react-icons/fa';
import ThemeToggle from '../../components/ThemeToggle';

import { auth, db } from "../../firebase/firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import Modal from "../../components/modal";
import BuyAirtime from "./BuyAirtime";
import BuyData from "./BuyData";
import CableSubscriptionForm from "./BuyTVSub";
import PayElectricityBill from "./BuyE-BillSub";
import PaystackPaymentForm from "../../components/paystack";





function Header({onToggleMenuClick, isOpen}) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeComponent, setActiveComponent] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const [showNotifications, setShowNotifications] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);
    const [isAdminDropdownOpen, setIsAdminDropdownOpen] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                try {
                    const userDocRef = doc(db, 'users', user.uid);
                    const userDoc = await getDoc(userDocRef);
                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        if (userData.role) {
                            setUserRole(userData.role.toLowerCase());
                        }
                    }
                } catch (error) {
                    console.error("Error fetching user role:", error);
                }
            } else {
                setUserRole(null);
            }
        });
        return () => unsubscribe();
    }, []);

    const fetchNotifications = async () => {
        if (!auth.currentUser) return;
        try {
            const token = await auth.currentUser.getIdToken();
            const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
            const res = await fetch(`${apiUrl}/api/v1/admin/notifications`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            if (res.ok) {
                const data = await res.json();
                setNotifications(data);
                
                const lastRead = localStorage.getItem('last_read_notifications') || '0';
                let unread = 0;
                data.forEach(n => {
                    if (new Date(n.timestamp).getTime() > parseInt(lastRead)) {
                        unread++;
                    }
                });
                setUnreadCount(unread);
            }
        } catch (error) {
            console.error("Failed to fetch notifications:", error);
        }
    };

    useEffect(() => {
        if (userRole !== null) {
            fetchNotifications();
        }
    }, [userRole]);

    const handleBellClick = () => {
        setShowNotifications(!showNotifications);
        if (!showNotifications && unreadCount > 0) {
            setUnreadCount(0);
            localStorage.setItem('last_read_notifications', Date.now().toString());
        }
    };

    const openModal = (component) => {
        setActiveComponent(() => component);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setActiveComponent(null);
    };
    
    const navigate = useNavigate();

    const handleLogout = async (e) => {
        e.preventDefault();
        await signOut(auth);
        alert("User logged out successfully!");
        navigate('/');
        // window.location.href = "/";
      };
    
    return ( 
    <div className = 'fixed z-50 w-full header-div bg-light1 text-dark2 dark:text-light1 dark:bg-dark1  ' >
        <Modal isOpen={isModalOpen} onClose={closeModal} contentComponent={activeComponent} />
        <div className = 'header-nav bg-light2 dark:bg-dark2 pr-4 rounded-lg' >
            <ul className = 'header-ul' >
                <li onClick={onToggleMenuClick} className='py-2 pr-2   hover:text-primary'>
                    <FaBars className=' w-12 h-6'/>
                </li>
                <li className = 'py-2 logo' >
                    <Link to ='/' className = 'header-a logo-container hover:text-primary' > 
                    <FaWifi className = 'logo-img text-primary mx-2' />
                    <span className = 'text-primary'> Jcoteck VTU </span> </Link> 
                </li > 
                <div
                 className={`${
                    isOpen ?  'w-64' : 'w-0 lg:w-16'
                  } fixed top-12 overflow-x-hidden left-0 h-full z-30 bg-light2 dark:bg-dark2 pt-2 transition-all duration-300 ease-in-out md:p-0`}
                
                 >
                 
                    <ul className='flex  flex-col h-screen overflow-y-auto no-scrollbar pb-24'>
                        { (userRole === 'admin' || userRole === 'staff') && (
                            <li className='pt-5'>
                                <div 
                                    onClick={() => setIsAdminDropdownOpen(!isAdminDropdownOpen)} 
                                    className='cursor-pointer flex justify-between items-center px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1'
                                >
                                    <div className='flex align-baseline'>
                                        <FaUserShield className="mr-4 my-1"/> 
                                        {isOpen ? 'Admin' : ''}
                                    </div>
                                    {isOpen && (isAdminDropdownOpen ? <FaChevronUp className="text-sm" /> : <FaChevronDown className="text-sm" />)}
                                </div>
                                {isAdminDropdownOpen && isOpen && (
                                    <ul className="pl-8 flex flex-col space-y-1 mt-1">
                                        <li>
                                            <Link to='/account/admin' className='flex no-underline px-4 py-2 text-sm hover:text-primary hover:bg-light1 dark:hover:bg-dark1 rounded'>
                                                <FaTachometerAlt className="mr-3 my-1"/> Dashboard
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/account/data-prices' className='flex no-underline px-4 py-2 text-sm hover:text-primary hover:bg-light1 dark:hover:bg-dark1 rounded'>
                                                <FaDatabase className="mr-3 my-1"/> Data Plans
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/account/airtime-prices' className='flex no-underline px-4 py-2 text-sm hover:text-primary hover:bg-light1 dark:hover:bg-dark1 rounded'>
                                                <FaPhone className="mr-3 my-1"/> Airtime Prices
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/account/users' className='flex no-underline px-4 py-2 text-sm hover:text-primary hover:bg-light1 dark:hover:bg-dark1 rounded'>
                                                <FaUsers className="mr-3 my-1"/> Users
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/account/notifications' className='flex no-underline px-4 py-2 text-sm hover:text-primary hover:bg-light1 dark:hover:bg-dark1 rounded'>
                                                <FaBell className="mr-3 my-1"/> Notifications
                                            </Link>
                                        </li>
                                        <li>
                                            <Link to='/account/settings' className='flex no-underline px-4 py-2 text-sm hover:text-primary hover:bg-light1 dark:hover:bg-dark1 rounded'>
                                                <FaCog className="mr-3 my-1"/> Settings
                                            </Link>
                                        </li>
                                    </ul>
                                )}
                            </li>
                        )}
                        <li className={(userRole === 'admin' || userRole === 'staff') ? '' : 'pt-5'}> 
                            <Link to= '/account' className = 'flex   no-underline px-4 py-2  hover:text-primary hover:bg-light1 dark:hover:bg-dark1  align-baseline' > <FaTachometerAlt className="mr-4 my-1"/> {isOpen ? 'Dashboard' : ''}  </Link>
                        </li >
                        <li> 
                               <div onClick={() => openModal(PaystackPaymentForm)} className = 'cursor-pointer flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaWallet   className="mr-4 my-1" />{isOpen ? 'Fund Wallet' : ''}  </div>
                        </li >
                        <li> 
                            <div onClick={() => openModal(BuyData)} className = 'cursor-pointer flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaSignal className="mr-4 my-1" />{isOpen ? 'Data' : ''}  </div>
                        </li >
                        <li> 
                            <div onClick={() => openModal(BuyAirtime)} className = 'cursor-pointer flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaPhoneVolume className="mr-4 my-1" />{isOpen ? 'Airtime' : ''}  </div>
                        </li >
                        <li> 
                            <Link to ='#faq-section' className = 'flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaGraduationCap className="mr-4 my-1"/>{isOpen ? 'E-Pins' : ''}  </Link>
                        </li >
                        <li> 
                            <div onClick={() => openModal(PayElectricityBill)} className = 'cursor-pointer flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaLightbulb className="mr-4 my-1" />{isOpen ? 'Electricity Bill' : ''}   </div>
                        </li >
                        <li> 
                            <div onClick={() => openModal(CableSubscriptionForm)} className = 'cursor-pointer flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaTv className="mr-4 my-1" />{isOpen ? 'TV Subscription' : ''}   </div>
                        </li >
                        <li> 
                            <Link to ='/account/transactions'   className = 'flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaExchangeAlt className="mr-4 my-1" />{isOpen ? 'Transactions' : ''}  </Link>
                        </li >
                        <li> 
                            <Link to ='/account/profile'   className = 'flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' ><FaUser className="mr-4 my-1" /> {isOpen ? 'Account' : ''} </Link>
                        </li >
                        <li> 
                            <Link to ='#contact-section' className = 'flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' > <FaRobot className="mr-4 my-1" />{isOpen ? 'Self Service' : ''}  </Link>
                        </li >
                        <li> 
                            <Link to ='#contact-section' className = 'flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' > <FaHeadset className="mr-4 my-1" />{isOpen ? ' Support' : ''} </Link>
                        </li >

                        <li> 
                            <Link to='' onClick={handleLogout}  className = 'flex align-middle  no-underline px-4 py-2 hover:text-primary hover:bg-light1 dark:hover:bg-dark1' > <FaSignOutAlt className="mr-4 my-1" />{isOpen ? 'Logout' : ''}  </Link>
                        </li >
                    </ul>
                    
                </div>
                <li>
                    <Link to ='/account/profile' >                    
                        <div className=" flex items-center justify-center h-10 w-10 rounded-full bg-light1 dark:bg-dark1 hover:text-primary ml-2 mr-1"><FaUser className='hover:text-primary m-2' /> </div>
                    </Link>
                </li>
                <li className="relative">
                    <div onClick={handleBellClick} className="cursor-pointer flex items-center justify-center h-10 w-10 rounded-full bg-light1 dark:bg-dark1 hover:text-primary mr-2 ml-1 relative">
                        <FaBell className='hover:text-primary m-2' /> 
                        {unreadCount > 0 && (
                            <span className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold w-4 h-4 rounded-full flex items-center justify-center">
                                {unreadCount}
                            </span>
                        )}
                    </div>
                    {showNotifications && (
                        <div className="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-md shadow-lg overflow-hidden z-50 border border-gray-200 dark:border-gray-700">
                            <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700 font-semibold text-gray-800 dark:text-white">
                                Notifications
                            </div>
                            <div className="max-h-64 overflow-y-auto">
                                {notifications.length > 0 ? (
                                    notifications.map(notif => (
                                        <div key={notif.id} className="px-4 py-3 border-b border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700">
                                            <h4 className="text-sm font-semibold text-gray-800 dark:text-gray-200">{notif.title}</h4>
                                            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">{notif.message}</p>
                                            <span className="text-[10px] text-gray-400 mt-2 block">{new Date(notif.timestamp).toLocaleString()}</span>
                                        </div>
                                    ))
                                ) : (
                                    <div className="px-4 py-6 text-center text-sm text-gray-500">
                                        No notifications yet.
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </li>
                <li>
                    <ThemeToggle className='px-2  hover:bg-light1 dark:hover:bg-dark1' /> 
                </li>
            </ul>          
        </div >
    </div>
    );
}

export default Header;